import React from 'react'
import { makeStyles, Table, TableBody, TableHead } from '@material-ui/core'
import { SystemContainerSidebarTableRow } from './SystemContainerSidebarTableRow'
import { reduceToSum } from '../../../util/array-utility'
import { FilteredResult } from '../../../calculators/calculator-result-utility'

const useStyles = makeStyles((theme) => ({
  table: {
    marginTop: theme.spacing(2),
  },
}))

export type SidebarRow = {
  title: string
  result: FilteredResult
  comparisonResult?: FilteredResult
}

type Props = {
  header: string
  rowData: SidebarRow[]
  isComparisonVisible?: boolean
}

export function SystemContainerSidebarTable({
  header,
  rowData,
  isComparisonVisible,
}: Props): React.ReactElement {
  const classes = useStyles()

  const totalEnergy = rowData
    .map((row) => row.result.total)
    .reduce(reduceToSum, 0)

  const totalComparisonEnergy = isComparisonVisible
    ? rowData
        .map((row) => row.comparisonResult?.total ?? 0)
        .reduce(reduceToSum, 0)
    : undefined

  const resultToTotal = (result: FilteredResult) =>
    result.isEmpty ? null : result.total

  return (
    <Table size="small" className={classes.table}>
      <TableHead>
        <SystemContainerSidebarTableRow
          title={header}
          energyValue={totalEnergy}
          comparisonValue={totalComparisonEnergy}
          isHeader
        />
      </TableHead>
      <TableBody>
        {rowData.map((row) => (
          <SystemContainerSidebarTableRow
            key={row.title}
            title={row.title}
            energyValue={resultToTotal(row.result)}
            comparisonValue={
              row.comparisonResult
                ? resultToTotal(row.comparisonResult)
                : undefined
            }
          />
        ))}
      </TableBody>
    </Table>
  )
}
